import * as um from 'generated/api/um.api';
import * as dm from 'generated/api/dm.api';

type GetAgentScores = dm.paths['/open-api/application-feedback/agentAgentScores/{userId}'];
export type GetAgentScoreParams = GetAgentScores['get']['parameters']['path']['userId'];
export type RawAgentScore = GetAgentScores['get']['responses']['200']['schema'];

type GetAgentClientScores = um.paths['/open-api/users/categories/{id}'];
export type GetAgentClientScoresParams = GetAgentClientScores['get']['parameters']['path']['id'];
export type RawAgentClientScore = GetAgentClientScores['get']['responses']['200']['schema'];

export class AgentScore {
  id: number;
  name: string;
  nameIcon: string;
  icon: string;
  count: number;
  constructor(data: AgentScore) {
    this.id = data.id;
    this.name = data.name;
    this.icon = data.icon;
    this.count = data.count;
    this.nameIcon = data.nameIcon;
  }
}
